export function queryMatches(query: string, text: string) {
  const lowerCasedQuery = query.toLowerCase()
  const lowerCased = text.toLowerCase()
  const withoutSpaces = lowerCased.replaceAll(' ', '')

  if (lowerCased.startsWith(lowerCasedQuery)) {
    return true
  }

  if (withoutSpaces.startsWith(lowerCasedQuery)) {
    return true
  }

  return false
}
